import { render, staticRenderFns } from "./BarChart.vue?vue&type=template&id=5b2c5fa5"
import script from "./BarChart.vue?vue&type=script&lang=js"
export * from "./BarChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b2c5fa5')) {
      api.createRecord('5b2c5fa5', component.options)
    } else {
      api.reload('5b2c5fa5', component.options)
    }
    module.hot.accept("./BarChart.vue?vue&type=template&id=5b2c5fa5", function () {
      api.rerender('5b2c5fa5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Charts/BarChart.vue"
export default component.exports